var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharepoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 813.9 559.9 144.8V41.2L10 186.1v627.8zm285.6-271.7C233.5 512 193 464.1 193 388.3c0-88.9 53.3-156.9 141.5-156.9 42.2 0 73.2 12.4 95.5 26.3l-19 95.1c-15-10-41.6-24.7-78.3-24.7-36.6 0-54.4 23.2-54.4 50.3 0 33.2 21.1 47.9 69.3 73.4 66.1 34 97.1 82 97.1 155.4 0 87.3-48.2 161.5-150.9 161.5-42.8 0-84.9-15.4-106-31.7l17.2-97.4c22.7 16.2 57.7 32.4 93.8 32.4 38.8 0 59.4-22.3 59.4-56.4.1-32.4-17.7-51.1-62.6-73.4zm572.2-182c-20.2 0-38.9 5.4-55.7 14l-74.3-74.4c4.9-13.1 7.8-27.1 7.8-42 0-65.7-52-118.9-117-121.6v243.3c12.9-.6 25.3-3.2 36.9-7.4l83.4 83.3c-2 8.6-3.3 17.5-3.3 26.8 0 30.2 11.4 57.5 29.6 78.8L703 633.6c-16.9-8.7-35.8-14.2-56-14.2-6.2 0-12.2.9-18.3 1.8v240.6c6 1 12.1 1.8 18.3 1.8 67.4 0 122-54.6 122-122 0-9.1-1.1-17.9-3-26.4l111.6-111.6c62.9-5.1 112.4-57.1 112.4-121.2-.1-67.5-54.8-122.2-122.2-122.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepoint);
export default __webpack_public_path__ + "static/media/sharepoint.cbe880b53e562c3b0bc6f13fba95dacb.svg";
export { ForwardRef as ReactComponent };